// extracted by mini-css-extract-plugin
export var card = "_ol-0";
export var content = "_ol-2";
export var details = "_ol-3";
export var icon = "_ol-1";
export var iconBlue = "_ol-5";
export var iconBrand = "_ol-4";
export var iconGrayBlue = "_ol-6";
export var iconGreen = "_ol-7";
export var iconIndigo = "_ol-8";
export var iconOrange = "_ol-9";
export var iconPurple = "_ol-a";
export var iconRed = "_ol-b";
export var iconWarning = "_ol-c";